module.exports = __webpack_public_path__ + "img/plot-factory-icon-black.3739c73e.png";